import { FlagProvider, IConfig } from '@unleash/proxy-client-react'
import getConfig from 'next/config'
import React, { PropsWithChildren, useContext } from 'react'

import StoresContext from '@/utils/StoresContext'

const {
  publicRuntimeConfig: { PUBLIC_UNLEASH_URL, PUBLIC_UNLEASH_API_KEY, PUBLIC_UNLEASH_ENABLED }
} = getConfig()

const REFRESH_INTERVAL = 600 // 10 minutes
const ENVIRONMENT = 'production'
const APP_NAME = 'bookings-widget-zenchef'

interface UnleashProviderProps extends PropsWithChildren {}

const UnleashProvider: React.FC<UnleashProviderProps> = ({ children }) => {
  const { appStore } = useContext(StoresContext)

  if (PUBLIC_UNLEASH_ENABLED !== 'true' || !PUBLIC_UNLEASH_URL || !PUBLIC_UNLEASH_API_KEY) {
    return <>{children}</>
  }

  const properties: { [key: string]: string } = {}
  if (appStore.state.restaurantId !== undefined) {
    properties.restaurantId = appStore.state.restaurantId
  }
  if (appStore.state.isTestRestaurant !== undefined) {
    properties.isTest = appStore.state.isTestRestaurant.toString()
  }
  if (appStore.state.restaurantCountry !== undefined) {
    properties.countryCode = appStore.state.restaurantCountry
  }

  // Configuration for the Unleash client
  const unleashConfig: IConfig = {
    url: PUBLIC_UNLEASH_URL,
    clientKey: PUBLIC_UNLEASH_API_KEY,
    appName: APP_NAME,
    environment: ENVIRONMENT,
    refreshInterval: REFRESH_INTERVAL,
    context: {
      properties
    }
  }

  return <FlagProvider config={unleashConfig}>{children}</FlagProvider>
}

export default UnleashProvider
